// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Production-level modern white UI for Machine Management */
:root {
    --bg-main: #f8fafc;
    --bg-card: #ffffff;
    --bg-input: #ffffff;
    --border: #e2e8f0;
    --border-hover: #cbd5e1;
    --text-primary: #0f172a;
    --text-secondary: #475569;
    --text-muted: #94a3b8;
    --accent: #4f46e5;
    --accent-foreground: #ffffff;
    --danger: #ef4444;
    --success: #10b981;
    --warning: #f59e0b;
    --radius: 12px;
    --font-sans: "Inter", system-ui, -apple-system, sans-serif;
    --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  }
  
  .view-machine-page {
    min-height: 100vh;
    background-color: var(--bg-main);
    color: var(--text-primary);
    font-family: var(--font-sans);
    padding: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
  }
  
  /* Header Section */
  .page-header {
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    background: white;
    padding: 2rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
  }
  
  .back-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--text-secondary);
    background: none;
    border: none;
    font-size: 0.875rem;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s;
  }
  
  .back-button:hover {
    color: var(--text-primary);
  }
  
  .header-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .header-info h1 {
    font-size: 2.25rem;
    font-weight: 700;
    margin: 0;
    letter-spacing: -0.025em;
  }
  
  .machine-subtitle {
    color: var(--text-secondary);
    margin-top: 0.25rem;
    font-size: 1rem;
  }
  
  /* Tab Navigation */
  .tabs-container {
    display: flex;
    gap: 0.5rem;
    background: white;
    padding: 0.5rem;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    margin-bottom: 2rem;
    box-shadow: var(--shadow-sm);
  }
  
  .tabs-container::-webkit-scrollbar {
    display: none;
  }
  
  .tab-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--text-secondary);
    font-weight: 500;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
    border-radius: calc(var(--radius) - 4px);
    border-bottom: none;
  }
  
  .tab-item:hover {
    color: var(--text-primary);
    background-color: #f1f5f9;
  }
  
  .tab-item.active {
    color: var(--accent);
    background-color: #eef2ff;
    border-bottom-color: transparent;
  }
  
  /* Stats Cards */
  .summary-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2.5rem;
  }
  
  .summary-card {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 1.5rem;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    box-shadow: var(--shadow-sm);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .summary-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow);
  }
  
  .card-icon {
    background: #eef2ff;
    color: var(--accent);
    padding: 0.75rem;
    border-radius: var(--radius);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .card-content h3 {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--text-secondary);
    margin: 0 0 0.25rem;
  }
  
  .big-value {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0;
  }
  
  /* Content Sections */
  .tab-section {
    animation: fadeIn 0.3s ease-out;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  /* Tables */
  .table-responsive {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
    width: 100%;
  }
  
  .data-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    font-size: 0.875rem;
  }
  
  .data-table th {
    padding: 1rem;
    background: #f8fafc;
    color: var(--text-secondary);
    font-weight: 600;
    border-bottom: 1px solid var(--border);
    white-space: nowrap;
  }
  
  .data-table td {
    padding: 1rem;
    border-bottom: 1px solid var(--border);
    vertical-align: middle;
  }
  
  .data-table tr:last-child td {
    border-bottom: none;
  }
  
  .data-table tr:hover {
    background: #f8fafc;
  }
  
  /* Status Badges */
  .status-badge {
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
  }
  
  .status-badge.active,
  .status-badge.completed,
  .status-badge.paid {
    background: #ecfdf5;
    color: #059669;
  }
  
  .status-badge.expired,
  .status-badge.pending {
    background: #fef2f2;
    color: #dc2626;
  }
  
  /* Documents & Actions */
  .document-links {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }
  
  .doc-link {
    color: var(--accent);
    text-decoration: none;
    font-size: 0.75rem;
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
  }
  
  .doc-link:hover {
    text-decoration: underline;
  }
  
  .actions-cell {
    display: flex;
    gap: 0.5rem;
  }
  
  .action-btn {
    padding: 0.4rem;
    border-radius: 4px;
    border: 1px solid var(--border);
    background: #f8fafc;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .action-btn:hover {
    color: var(--text-primary);
    border-color: var(--border-hover);
    background: #f1f5f9;
  }
  
  .action-btn.delete-btn:hover {
    color: var(--danger);
    border-color: var(--danger);
  }
  
  /* Buttons */
  .add-button,
  .submit-btn {
    background: var(--accent);
    color: var(--accent-foreground);
    border: none;
    padding: 0.5rem 1rem;
    border-radius: var(--radius);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  
  .add-button:hover,
  .submit-btn:hover {
    opacity: 0.9;
  }
  
  .cancel-btn {
    background: transparent;
    color: var(--text-secondary);
    border: 1px solid var(--border);
    padding: 0.5rem 1rem;
    border-radius: var(--radius);
    cursor: pointer;
  }
  
  /* Modal */
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
  }
  
  .modal-content {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  }
  
  .modal-header {
    padding: 1.25rem;
    border-bottom: 1px solid var(--border);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-header h3 {
    margin: 0;
    font-size: 1.125rem;
  }
  
  .close-modal-btn {
    background: none;
    border: none;
    color: var(--text-muted);
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
  
  /* Form Styles */
  .form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .form-group.full {
    grid-column: span 2;
  }
  
  .form-group label {
    font-size: 0.875rem;
    color: var(--text-secondary);
    font-weight: 500;
  }
  
  .form-group input,
  .form-group select {
    background: var(--bg-input);
    border: 1px solid var(--border);
    border-radius: 6px;
    padding: 0.625rem;
    color: var(--text-primary);
    width: 100%;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  .form-group input:focus {
    outline: none;
    border-color: var(--accent);
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }
  
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  
  /* Responsive Overrides */
  @media (max-width: 768px) {
    .view-machine-page {
      padding: 1rem;
    }
  
    .header-info h1 {
      font-size: 1.75rem;
    }
  
    .form-grid {
      grid-template-columns: 1fr;
    }
  
    .form-group.full {
      grid-column: span 1;
    }
  
    .summary-cards {
      grid-template-columns: 1fr;
    }
  
    .table-responsive {
      overflow-x: auto;
    }
  }
  
  .empty-state {
    text-align: center;
    padding: 3rem 1rem;
    color: var(--text-muted);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .loading-screen,
  .error-screen {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-main);
    color: var(--text-primary);
  }




/* ===== Modal Overlay ===== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55); /* slate overlay */
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ===== Modal Container ===== */
.modal {
  background: #ffffff;
  width: 420px;
  max-width: 92%;
  border-radius: 14px;
  padding: 22px 24px 24px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: modalFadeIn 0.25s ease-out;
}

/* ===== Header ===== */
.modal h3 {
  margin: 0 0 18px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

/* ===== Form Fields ===== */
.modal select,
.modal input[type="file"] {
  width: 100%;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 0.95rem;
  background: #fff;
  color: #111827;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.modal select:focus,
.modal input[type="file"]:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

/* ===== File Input Styling ===== */
.modal input[type="file"]::file-selector-button {
  background: #f1f5f9;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 0.85rem;
  cursor: pointer;
  margin-right: 10px;
  transition: background 0.2s ease;
}

.modal input[type="file"]::file-selector-button:hover {
  background: #e2e8f0;
}

/* ===== Action Buttons ===== */
.modal .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}

.modal button {
  padding: 9px 16px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

/* Cancel Button */
.modal button:first-child {
  background: #f3f4f6;
  color: #374151;
}

.modal button:first-child:hover {
  background: #e5e7eb;
}

/* Primary Button */
.modal button:last-child {
  background: #2563eb;
  color: #ffffff;
}

.modal button:last-child:hover {
  background: #1d4ed8;
}

.modal button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== Animation ===== */
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/* Add to ViewMachine.css */
.fuel-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.fuel-table-wrapper::-webkit-scrollbar {
  height: 6px;
}

.fuel-table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.fuel-table-wrapper::-webkit-scrollbar-thumb {
  background: #94a3b8;
  border-radius: 3px;
}

/* Status badge styles */
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

/* Green for normal */
.status-normal {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

/* Red for any other status (different, abnormal, warning, etc.) */
.status-different {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Machine/ViewMachine.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,0DAA0D;IAC1D,0CAA0C;IAC1C,0EAA0E;EAC5E;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;IAChC,0BAA0B;IAC1B,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA,mBAAmB;EACnB;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,4BAA4B;IAC5B,2CAA2C;EAC7C;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;EACX;;EAEA,qBAAqB;EACrB;IACE,+BAA+B;EACjC;;EAEA;IACE;MACE,UAAU;MACV,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA,WAAW;EACX;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,4BAA4B;IAC5B,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;;;IAGE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA,YAAY;EACZ;;IAEE,yBAAyB;IACzB,+BAA+B;IAC/B,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,wBAAwB;EAC1B;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,oBAAoB;IACpB,4BAA4B;IAC5B,eAAe;EACjB;;EAEA,UAAU;EACV;IACE,eAAe;IACf,QAAQ;IACR,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,+EAA+E;EACjF;;EAEA;IACE,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;;IAEE,2BAA2B;IAC3B,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;IACX,8CAA8C;EAChD;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;;EAEA,yBAAyB;EACzB;IACE;MACE,aAAa;IACf;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;EAC5B;;;;;AAKF,8BAA8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC,EAAE,kBAAkB;EACtD,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;;EAEE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;AACA,2BAA2B;AAC3B;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Production-level modern white UI for Machine Management */\n:root {\n    --bg-main: #f8fafc;\n    --bg-card: #ffffff;\n    --bg-input: #ffffff;\n    --border: #e2e8f0;\n    --border-hover: #cbd5e1;\n    --text-primary: #0f172a;\n    --text-secondary: #475569;\n    --text-muted: #94a3b8;\n    --accent: #4f46e5;\n    --accent-foreground: #ffffff;\n    --danger: #ef4444;\n    --success: #10b981;\n    --warning: #f59e0b;\n    --radius: 12px;\n    --font-sans: \"Inter\", system-ui, -apple-system, sans-serif;\n    --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  }\n  \n  .view-machine-page {\n    min-height: 100vh;\n    background-color: var(--bg-main);\n    color: var(--text-primary);\n    font-family: var(--font-sans);\n    padding: 1.5rem;\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n  \n  /* Header Section */\n  .page-header {\n    margin-bottom: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    background: white;\n    padding: 2rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .back-button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: var(--text-secondary);\n    background: none;\n    border: none;\n    font-size: 0.875rem;\n    cursor: pointer;\n    padding: 0;\n    transition: color 0.2s;\n  }\n  \n  .back-button:hover {\n    color: var(--text-primary);\n  }\n  \n  .header-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .header-info h1 {\n    font-size: 2.25rem;\n    font-weight: 700;\n    margin: 0;\n    letter-spacing: -0.025em;\n  }\n  \n  .machine-subtitle {\n    color: var(--text-secondary);\n    margin-top: 0.25rem;\n    font-size: 1rem;\n  }\n  \n  /* Tab Navigation */\n  .tabs-container {\n    display: flex;\n    gap: 0.5rem;\n    background: white;\n    padding: 0.5rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--border);\n    margin-bottom: 2rem;\n    box-shadow: var(--shadow-sm);\n  }\n  \n  .tabs-container::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .tab-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    background: none;\n    border: none;\n    border-bottom: 2px solid transparent;\n    color: var(--text-secondary);\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n    border-radius: calc(var(--radius) - 4px);\n    border-bottom: none;\n  }\n  \n  .tab-item:hover {\n    color: var(--text-primary);\n    background-color: #f1f5f9;\n  }\n  \n  .tab-item.active {\n    color: var(--accent);\n    background-color: #eef2ff;\n    border-bottom-color: transparent;\n  }\n  \n  /* Stats Cards */\n  .summary-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2.5rem;\n  }\n  \n  .summary-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    padding: 1.5rem;\n    display: flex;\n    align-items: flex-start;\n    gap: 1rem;\n    box-shadow: var(--shadow-sm);\n    transition: transform 0.2s, box-shadow 0.2s;\n  }\n  \n  .summary-card:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow);\n  }\n  \n  .card-icon {\n    background: #eef2ff;\n    color: var(--accent);\n    padding: 0.75rem;\n    border-radius: var(--radius);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .card-content h3 {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: var(--text-secondary);\n    margin: 0 0 0.25rem;\n  }\n  \n  .big-value {\n    font-size: 1.5rem;\n    font-weight: 700;\n    margin: 0;\n  }\n  \n  /* Content Sections */\n  .tab-section {\n    animation: fadeIn 0.3s ease-out;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n  }\n  \n  .section-header h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  /* Tables */\n  .table-responsive {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-sm);\n    overflow: hidden;\n    width: 100%;\n  }\n  \n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n    text-align: left;\n    font-size: 0.875rem;\n  }\n  \n  .data-table th {\n    padding: 1rem;\n    background: #f8fafc;\n    color: var(--text-secondary);\n    font-weight: 600;\n    border-bottom: 1px solid var(--border);\n    white-space: nowrap;\n  }\n  \n  .data-table td {\n    padding: 1rem;\n    border-bottom: 1px solid var(--border);\n    vertical-align: middle;\n  }\n  \n  .data-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .data-table tr:hover {\n    background: #f8fafc;\n  }\n  \n  /* Status Badges */\n  .status-badge {\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n  }\n  \n  .status-badge.active,\n  .status-badge.completed,\n  .status-badge.paid {\n    background: #ecfdf5;\n    color: #059669;\n  }\n  \n  .status-badge.expired,\n  .status-badge.pending {\n    background: #fef2f2;\n    color: #dc2626;\n  }\n  \n  /* Documents & Actions */\n  .document-links {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n  \n  .doc-link {\n    color: var(--accent);\n    text-decoration: none;\n    font-size: 0.75rem;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.25rem;\n  }\n  \n  .doc-link:hover {\n    text-decoration: underline;\n  }\n  \n  .actions-cell {\n    display: flex;\n    gap: 0.5rem;\n  }\n  \n  .action-btn {\n    padding: 0.4rem;\n    border-radius: 4px;\n    border: 1px solid var(--border);\n    background: #f8fafc;\n    color: var(--text-secondary);\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .action-btn:hover {\n    color: var(--text-primary);\n    border-color: var(--border-hover);\n    background: #f1f5f9;\n  }\n  \n  .action-btn.delete-btn:hover {\n    color: var(--danger);\n    border-color: var(--danger);\n  }\n  \n  /* Buttons */\n  .add-button,\n  .submit-btn {\n    background: var(--accent);\n    color: var(--accent-foreground);\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius);\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: opacity 0.2s;\n  }\n  \n  .add-button:hover,\n  .submit-btn:hover {\n    opacity: 0.9;\n  }\n  \n  .cancel-btn {\n    background: transparent;\n    color: var(--text-secondary);\n    border: 1px solid var(--border);\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius);\n    cursor: pointer;\n  }\n  \n  /* Modal */\n  .modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.4);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n  }\n  \n  .modal-content {\n    background: var(--bg-card);\n    border: 1px solid var(--border);\n    border-radius: var(--radius);\n    width: 100%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n  }\n  \n  .modal-header {\n    padding: 1.25rem;\n    border-bottom: 1px solid var(--border);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .modal-header h3 {\n    margin: 0;\n    font-size: 1.125rem;\n  }\n  \n  .close-modal-btn {\n    background: none;\n    border: none;\n    color: var(--text-muted);\n    font-size: 1.5rem;\n    cursor: pointer;\n  }\n  \n  .modal-body {\n    padding: 1.5rem;\n  }\n  \n  /* Form Styles */\n  .form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n  \n  .form-group {\n    margin-bottom: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .form-group.full {\n    grid-column: span 2;\n  }\n  \n  .form-group label {\n    font-size: 0.875rem;\n    color: var(--text-secondary);\n    font-weight: 500;\n  }\n  \n  .form-group input,\n  .form-group select {\n    background: var(--bg-input);\n    border: 1px solid var(--border);\n    border-radius: 6px;\n    padding: 0.625rem;\n    color: var(--text-primary);\n    width: 100%;\n    transition: border-color 0.2s, box-shadow 0.2s;\n  }\n  \n  .form-group input:focus {\n    outline: none;\n    border-color: var(--accent);\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  }\n  \n  .form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 1rem;\n  }\n  \n  /* Responsive Overrides */\n  @media (max-width: 768px) {\n    .view-machine-page {\n      padding: 1rem;\n    }\n  \n    .header-info h1 {\n      font-size: 1.75rem;\n    }\n  \n    .form-grid {\n      grid-template-columns: 1fr;\n    }\n  \n    .form-group.full {\n      grid-column: span 1;\n    }\n  \n    .summary-cards {\n      grid-template-columns: 1fr;\n    }\n  \n    .table-responsive {\n      overflow-x: auto;\n    }\n  }\n  \n  .empty-state {\n    text-align: center;\n    padding: 3rem 1rem;\n    color: var(--text-muted);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n  }\n  \n  .loading-screen,\n  .error-screen {\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--bg-main);\n    color: var(--text-primary);\n  }\n\n\n\n\n/* ===== Modal Overlay ===== */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55); /* slate overlay */\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* ===== Modal Container ===== */\n.modal {\n  background: #ffffff;\n  width: 420px;\n  max-width: 92%;\n  border-radius: 14px;\n  padding: 22px 24px 24px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: modalFadeIn 0.25s ease-out;\n}\n\n/* ===== Header ===== */\n.modal h3 {\n  margin: 0 0 18px;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #0f172a;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 12px;\n}\n\n/* ===== Form Fields ===== */\n.modal select,\n.modal input[type=\"file\"] {\n  width: 100%;\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 0.95rem;\n  background: #fff;\n  color: #111827;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n}\n\n.modal select:focus,\n.modal input[type=\"file\"]:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n/* ===== File Input Styling ===== */\n.modal input[type=\"file\"]::file-selector-button {\n  background: #f1f5f9;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  margin-right: 10px;\n  transition: background 0.2s ease;\n}\n\n.modal input[type=\"file\"]::file-selector-button:hover {\n  background: #e2e8f0;\n}\n\n/* ===== Action Buttons ===== */\n.modal .modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 22px;\n}\n\n.modal button {\n  padding: 9px 16px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s ease;\n}\n\n/* Cancel Button */\n.modal button:first-child {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.modal button:first-child:hover {\n  background: #e5e7eb;\n}\n\n/* Primary Button */\n.modal button:last-child {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.modal button:last-child:hover {\n  background: #1d4ed8;\n}\n\n.modal button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ===== Animation ===== */\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n/* Add to ViewMachine.css */\n.fuel-table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.fuel-table-wrapper::-webkit-scrollbar {\n  height: 6px;\n}\n\n.fuel-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n.fuel-table-wrapper::-webkit-scrollbar-thumb {\n  background: #94a3b8;\n  border-radius: 3px;\n}\n\n/* Status badge styles */\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n/* Green for normal */\n.status-normal {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n/* Red for any other status (different, abnormal, warning, etc.) */\n.status-different {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
